import { useState, useEffect } from "react";
import { checkPrinterStatus } from "@/hooks/usePrintLabel";

export type PrinterStatus = "checking" | "online" | "offline";

export interface PrinterState {
  status:        PrinterStatus;
  ribbonPercent: number | null;
}

const POLL_MS = 30_000;

export function usePrinterStatus(): PrinterState {
  const [state, setState] = useState<PrinterState>({ status: "checking", ribbonPercent: null });

  useEffect(() => {
    let cancelled = false;

    async function poll() {
      const result = await checkPrinterStatus();
      if (!cancelled) {
        setState({
          status:        result.reachable ? "online" : "offline",
          ribbonPercent: result.ribbonPercent,
        });
      }
    }

    poll();
    const id = setInterval(poll, POLL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return state;
}

// ── Last print job ────────────────────────────────────────────────────────

const LS_KEY = "ga:last-print-qty";

export function saveLastPrintQty(qty: number) {
  try { localStorage.setItem(LS_KEY, String(qty)); } catch {}
}

export function loadLastPrintQty(): number | null {
  try {
    const v = localStorage.getItem(LS_KEY);
    const n = v ? parseInt(v, 10) : NaN;
    return isNaN(n) || n < 1 ? null : n;
  } catch {
    return null;
  }
}
